import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Fade out the inline white boot screen once React has mounted.
requestAnimationFrame(() => {
  const boot = document.getElementById('boot-loader')
  if (!boot) return
  boot.classList.add('is-fading')
  setTimeout(() => boot.remove(), 500)
})
